/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Automix_Preset_LabelInputs */

const en_audio_description_export_automix_preset_label = /** @type {(inputs: Audio_Description_Export_Automix_Preset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mix Preset`)
};

const fr_audio_description_export_automix_preset_label = /** @type {(inputs: Audio_Description_Export_Automix_Preset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Préréglage de mix`)
};

const de_audio_description_export_automix_preset_label = /** @type {(inputs: Audio_Description_Export_Automix_Preset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mix-Voreinstellung`)
};

const it_audio_description_export_automix_preset_label = /** @type {(inputs: Audio_Description_Export_Automix_Preset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preimpostazione di mixaggio`)
};

const ru_audio_description_export_automix_preset_label = /** @type {(inputs: Audio_Description_Export_Automix_Preset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Предварительный микс`)
};

const es_audio_description_export_automix_preset_label = /** @type {(inputs: Audio_Description_Export_Automix_Preset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preajuste de mezcla`)
};

const zh_cn2_audio_description_export_automix_preset_label = /** @type {(inputs: Audio_Description_Export_Automix_Preset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`混合预设`)
};

const ja_audio_description_export_automix_preset_label = /** @type {(inputs: Audio_Description_Export_Automix_Preset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ミックスプリセット`)
};

const hi_audio_description_export_automix_preset_label = /** @type {(inputs: Audio_Description_Export_Automix_Preset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मिक्स प्रीसेट`)
};

const pt_pt2_audio_description_export_automix_preset_label = /** @type {(inputs: Audio_Description_Export_Automix_Preset_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mix Preset`)
};

/**
* | output |
* | --- |
* | "Mix Preset" |
*
* @param {Audio_Description_Export_Automix_Preset_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_automix_preset_label = /** @type {((inputs?: Audio_Description_Export_Automix_Preset_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Automix_Preset_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_automix_preset_label(inputs)
	if (locale === "de") return de_audio_description_export_automix_preset_label(inputs)
	if (locale === "it") return it_audio_description_export_automix_preset_label(inputs)
	if (locale === "ru") return ru_audio_description_export_automix_preset_label(inputs)
	if (locale === "es") return es_audio_description_export_automix_preset_label(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_automix_preset_label(inputs)
	if (locale === "ja") return ja_audio_description_export_automix_preset_label(inputs)
	if (locale === "hi") return hi_audio_description_export_automix_preset_label(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_automix_preset_label(inputs)
	return en_audio_description_export_automix_preset_label(inputs)
});